import { type CanvasElementId } from '@blaze-runtime/engine-domain';
import { type WorkflowId } from '@blaze-shared/api-contracts-domain';
import {
  type CanvasElementInputBinding,
  type ItemContainerActionsIds,
} from '@blaze-shared/elements-domain';

export interface AIState {
  ai: {
    updatedBindings: {
      elementId: CanvasElementId;
      bindingKey: CanvasElementInputBinding;
    }[];
    generateDialogs: {
      elementId: CanvasElementId;
      path: string;
    }[];
    generateDeleteRowActions: {
      elementId: CanvasElementId;
      actionPath: string;
    }[];
    generateRowClickActions: {
      elementId: CanvasElementId;
      actionPath: string;
      action: ItemContainerActionsIds;
    }[];
    updatedCharts: {
      elementId: CanvasElementId;
    }[];
    updatedWorkflows: WorkflowId[];
    elementsMap: Record<string, CanvasElementId>;
    error?: string;
  };
}

export const initialAIState: AIState = {
  ai: {
    updatedBindings: [],
    generateDialogs: [],
    generateDeleteRowActions: [],
    generateRowClickActions: [],
    updatedCharts: [],
    updatedWorkflows: [],
    elementsMap: {},
    error: undefined,
  },
};
